import React, { Component } from "react";
import "./SettingsBox.css";
import { Divider } from "antd";
import CloseModalButton from "./CloseModalButton";
import { connect } from "react-redux";
import { setIsSettingsModalVisible } from "../../store/user/actions";

interface Props {
  titleText: string;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  dividerStyle?: React.CSSProperties;
  setIsSettingsModalVisible: (visible: boolean) => void;
}

//User for settings of any kind: account, website. Adds vertical margins between inputs.
class SettingsBox extends Component<Props> {
  render() {
    return (
      <div className="settings-box" style={this.props.style}>
        <h2 className="settings-box__title" style={this.props.titleStyle}>
          {this.props.titleText}<CloseModalButton onClick={() => {
            this.props.setIsSettingsModalVisible(false);
          }} />
        </h2>
        <Divider
          className="settings__divider"
          style={this.props.dividerStyle}
        />
        {this.props.children}
      </div>
    );
  }
}

export default connect(null, { setIsSettingsModalVisible })(SettingsBox);
